import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Form, Button, Card, Row, Col, FloatingLabel } from "react-bootstrap";
import axios from "axios";
import PageLayout from "../../layouts/PageLayout";
import { DivideTitleComponent } from "../../components";

const AssesmentForm = () => {
    const {person_id} = useParams()
    const AuthToken = localStorage.getItem("AuthUser");
    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
    const [family, setFamily] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [completedPersons, setCompletedPersons] = useState([]);
    const [currentPerson, setCurrentPerson] = useState(null);
    const [personImage, setPersonImage] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + "/assessment-questions/"+ person_id);
                if (response.data.success) {
                    setQuestions(response.data.questions);
                    const familyData = response.data.family.map((member, index) => ({
                        id: index + 1,
                        name: member.name ?? "",
                        relation: member.relation,
                        answers: {},
                    }));
                    setFamily(familyData);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    const handleSelectMember = (e) => {
        const personId = Number(e.target.value);
        const selected = family.find((member) => member.id === personId);
        setCurrentPerson({ ...selected, answers: {} });
        setPersonImage(null);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setPersonImage(file);
    };

    const handleAnswerChange = (e, category, id) => {
        const { value } = e.target;
        setCurrentPerson((prev) => ({
            ...prev,
            answers: {
                ...prev.answers,
                [category]: {
                    ...(prev.answers[category] || {}),
                    [id]: value
                }
            }
        }));
    };

    const handleSaveAnswers = () => {
        const updatedPerson = { ...currentPerson, image: personImage };
        setCompletedPersons([...completedPersons, updatedPerson]);
        setFamily((prev) => prev.filter((member) => member.id !== currentPerson.id));
        setCurrentPerson(null);
        setPersonImage(null);
    };

    const handleSubmitToBackend = async () => {
        try {
            const formData = new FormData();
            formData.append('person_id', person_id)
            completedPersons.forEach((member, index) => {
                formData.append(`persons[${index}][name]`, member.name);
                formData.append(`persons[${index}][relation]`, member.relation);
                if (member.image) {
                    formData.append(`persons[${index}][image]`, member.image);
                }

                // Convert answers to an array of objects
                const answersArray = [];
                Object.keys(member.answers).forEach((category) => {
                    Object.keys(member.answers[category]).forEach((id) => {
                        answersArray.push({
                            question_id: Number(id), // Ensure questionId is a number
                            answer: member.answers[category][id],
                        });
                    });
                });

                // Append answers as JSON string
                formData.append(`persons[${index}][answers]`, JSON.stringify(answersArray));
            });

            const response = await axios.post(process.env.REACT_APP_API_URL + "/store-assessment", formData);
            if (response.data.success) {
                alert("Data submitted successfully");
                setCompletedPersons([]);
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Failed to submit data");
        }
    };

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <Card className="p-4 mt-3">
                        <Form>
                            {!currentPerson && family.length > 0 && (
                                <Form.Group controlId="selectPerson">
                                    <Form.Label>Select a Person</Form.Label>
                                    <Form.Control as="select" onChange={handleSelectMember} defaultValue="">
                                        <option value="">Select a person</option>
                                        {family.map((member) => (
                                            <option key={member.id} value={member.id}>
                                                {member.relation} - {member.name}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            )}

                            {currentPerson && (
                                <div className="mt-4">
                                    <h5>Questions for {currentPerson.relation} - {currentPerson.name}</h5>

                                    <Form.Group controlId="uploadImage" className="mb-3">
                                        <Form.Label>Upload Person Picture</Form.Label>
                                        <Form.Control type="file" onChange={handleImageChange} />
                                        {personImage && (
                                            <img
                                                src={URL.createObjectURL(personImage)}
                                                alt="Person Preview"
                                                className="mt-3 rounded"
                                                width={150}
                                                height={150}
                                            />
                                        )}
                                    </Form.Group>

                                    {Object.keys(questions).map((category) => (
                                        <Row key={category} className="mb-3">
                                            <DivideTitleComponent title={category.toUpperCase() + " ASSESMENT"} className="mb-4 mt-3" />
                                            {questions[category].map(({ id, question }) => (
                                                <Form.Group as={Col} md={6} key={id}>
                                                    <FloatingLabel label={question} className="mb-3">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter answer"
                                                            value={currentPerson.answers[category]?.[id] || ""}
                                                            onChange={(e) => handleAnswerChange(e, category, id)}
                                                        />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            ))}
                                        </Row>
                                    ))}
                                    <Button variant="success" className="mt-3" onClick={handleSaveAnswers}>
                                        Save Answers & Select Next Person
                                    </Button>
                                </div>
                            )}
                        </Form>

                        {completedPersons.length > 0 && (
                            <Card className="mt-4 p-3">
                                <h5>Completed Responses</h5>
                                {completedPersons.map((member) => (
                                    <div key={member.id} className="mb-3">
                                        {member.image && (
                                            <img src={URL.createObjectURL(member.image)} alt={member.name} className="rounded mb-2" width={150} height={150} />
                                        )}
                                        <strong>{member.relation} - {member.name}</strong>
                                        <div className="mt-2">
                                            {Object.keys(member.answers).map((category) => (
                                                <div key={category}>
                                                    <h6>{category.toUpperCase()}</h6>
                                                    {Object.keys(member.answers[category]).map((id) => {
                                                        // Convert the id from string to number
                                                        const questionId = Number(id);
                                                        const question = questions[category]?.find(q => q.id === questionId)?.question;
                                                        return (
                                                            <div key={id}>
                                                                <strong>Q: {question}</strong>
                                                                <p>A: {member.answers[category][id]}</p>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                                <Button variant="primary" className="mt-3" onClick={handleSubmitToBackend}>
                                    Submit All Data
                                </Button>
                            </Card>
                        )}
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
};

export default AssesmentForm;